var React = require('react');

function Squiggles (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M351.343 121C203.076 157.757 0 271 0 271V357.5H1439V0.5C1439 0.5 1257.31 114.5 1000.32 138C743.341 161.5 610.176 56.832 351.343 121Z","fill":"#E5F0FD","key":0}),React.createElement("path",{"d":"M351.343 151C203.076 187.757 0 320 0 320V357H1439V30.5C1439 30.5 1257.31 144.5 1000.32 168C743.341 191.5 610.176 86.832 351.343 151Z","fill":"#B2D2FB","key":1}),React.createElement("path",{"d":"M351.343 176C203.076 212.757 0 358.5 0 358.5H1439V76C1439 76 1257.31 169.5 1000.32 193C743.341 216.5 610.176 111.832 351.343 176Z","fill":"white","key":2})]);
}

Squiggles.defaultProps = {"width":"1439","height":"359","viewBox":"0 0 1439 359","fill":"none"};

module.exports = Squiggles;

Squiggles.default = Squiggles;
